import { VariantType } from "notistack";
import { Action, AnyAction } from "redux";

export interface Notification{
    id:string,
    text:string,
    timeout:number,
    type:VariantType
}

/**
 * 网站通知
 * @param state 
 * @param action 
 * @returns 
 */
const notification = (state:Notification[] = [], action:AnyAction) =>
{
	switch (action.type)
	{
		case 'ADD_NOTIFICATION':
		{
			const { notification } = action.payload;

			return [ ...state, notification ];
		}

		case 'REMOVE_NOTIFICATION':
		{
			const { notificationId } = action.payload;

			return state.filter((notification) => (notification as any).id !== notificationId);
		}

		case 'REMOVE_ALL_NOTIFICATIONS':
		{
			return [];
		}

		default:
			return state;
	}
};

export default notification;